function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

import { isArray } from '@cloud-sn/v-utils';
import Tree from '../tree';
var _Tree$staticMethod = Tree.staticMethod,
    getNodeStatus = _Tree$staticMethod.getNodeStatus,
    getNodeChildCheckState = _Tree$staticMethod.getNodeChildCheckState,
    getParentChecked = _Tree$staticMethod.getParentChecked,
    getOriginNodes = _Tree$staticMethod.getOriginNodes,
    getNodeOriginParent = _Tree$staticMethod.getNodeOriginParent;
export { getNodeStatus, getNodeChildCheckState, getParentChecked, getOriginNodes, getNodeOriginParent };
export function isValidValue(val) {
  return val || val === 0;
}
export var DEFAULT_FIELD_NAMES = {
  label: 'title',
  value: 'key',
  children: 'children'
};
export function normalizeContent(maxLen, content) {
  var l = Number(maxLen);

  if (l <= 0 || typeof content !== 'string' || content.length < l) {
    return content;
  }

  return "".concat(content.slice(0, l), "...");
}
export function isDisabledNode(node) {
  var isCheckable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var disabled = node.disabled;

  if (isCheckable) {
    disabled = disabled || node.disableCheckbox;
  }

  return node ? disabled : true;
}
export function getChildNodeKeys() {
  var node = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var keyName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_FIELD_NAMES.value;
  var isCheckable = arguments.length > 2 ? arguments[2] : undefined;
  var clearDisabled = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var ret = [];
  var children = node.children;

  if (isArray(children) && children.length > 0) {
    children.forEach(function (v) {
      if (!isDisabledNode(v) || clearDisabled) {
        ret.push(v[keyName]);
      }

      ret.push.apply(ret, _toConsumableArray(getChildNodeKeys(v, keyName, isCheckable, clearDisabled)));
    });
  }

  return ret;
}
export function checkNodeForShowParent(node) {
  var checkedNodeKeyObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var keyName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_FIELD_NAMES.value;
  var parentNode = node.parentNode;

  while (parentNode && isDisabledNode(parentNode)) {
    // eslint-disable-next-line
    parentNode = parentNode.parentNode;
  }

  if (!parentNode) {
    return true;
  }

  return !(parentNode[keyName] in checkedNodeKeyObj);
}
export function getNodeParentKeys() {
  var node = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var keyName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_FIELD_NAMES.value;
  var isCheckable = arguments.length > 2 ? arguments[2] : undefined;
  var clearDisabled = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var np = node.parentNode;
  var ret = [];

  if (!np) {
    return ret;
  }

  while (np) {
    if (!isDisabledNode(np, isCheckable) || clearDisabled) {
      ret.push(np[keyName]);
    }

    np = np.parentNode;
  }

  return ret;
}
export function calcMultipleSearchInputWidth(inputValue, inputMirror) {
  if (inputValue && inputMirror) {
    return {
      width: "".concat(inputMirror.clientWidth, "px")
    };
  }

  return {};
}